import { defineStore } from 'pinia'
import localSave from '@utils/local-save'
import DataLayer from '@services/data-layer/index'

export const useMemberStore = defineStore('member', {
    state: () => ({
        currentMember: {},
        passState: null,
        isLoading: true,
    }),
    actions: {
        setCurrentMember(member) {
            this.currentMember = member
            localSave.save('user.currentMember', member)
        },
        setPassState(passState) {
            this.passState = passState
        },
        setLoading(isLoading) {
            this.isLoading = isLoading
        },
        async init(currentUser) {
            if (!currentUser || !currentUser.members_id) return

            const savedMember = localSave.get('user.currentMember')
            if (savedMember) this.setCurrentMember(savedMember)

            const { body, headers } = await DataLayer.members.getById({
                id: currentUser.members_id.id,
                includePasswordState: true,
            })

            this.setCurrentMember(body)
            this.setPassState(headers['x-password-state'])
            this.setLoading(false)
        },
        destroy() {
            this.setCurrentMember(null)
            this.setPassState(null)
        },
    },
})
